import { LOCALE_EN, LOCALE_DE } from '@src/constants';

export const currentLanguage = ({ language, currentUser } = {}) => {
  const hopsLanguage = language;
  const userLanguage = currentUser?.accountSettings?.language?.value;

  const selectedLanguage = hopsLanguage || userLanguage;

  // We only support en/de
  return selectedLanguage !== LOCALE_EN ? LOCALE_DE : LOCALE_EN;
};
